import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-logo-circle" }, null, -1)
const _hoisted_2 = { for: "fileInput" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
        key: 0,
        onHide: _ctx.hidePopUp,
        "hide-bottom-decoration": "",
        "hide-top-decoration": ""
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$localize('message.file.selector.popup.title')), 1)
        ]),
        body: _withCtx(() => [
          _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openFileList }, {
            icon: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('message.file.selector.popup.casedrive')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("label", _hoisted_2, [
            _createVNode(_component_bottom_pop_up_item, null, {
              icon: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('message.file.selector.popup.upload.file_type')) + " ", 1)
              ]),
              _: 1
            }),
            _createElementVNode("input", {
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadFile($event))),
              id: "fileInput",
              ref: "fileInput",
              style: {"visibility":"hidden"},
              type: "file"
            }, null, 544)
          ])
        ]),
        _: 1
      }, 8, ["onHide"]))
    : _createCommentVNode("", true)
}